import Markdown from 'react-markdown';
import { MouseEvent } from 'react';

function CitationLink({ children, href, onOpenCitations }: any) {
  const text = children.replace(/[[\]]/g, '');
  return (
    <a href={href} data-citation={text} onClick={onOpenCitations}>
      {children}
    </a>
  );
}

interface WidgetAiTextWithCitationsProps {
  text: string | undefined;
  onOpenCitations: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export default function WidgetAiTextWithCitations({
  text,
  onOpenCitations,
}: WidgetAiTextWithCitationsProps) {
  if (!text) {
    console.warn('No Text Return Null');
    return null;
  }

  return (
    <Markdown
      components={{
        a: ({ children, href }) => (
          <CitationLink href={href} onOpenCitations={onOpenCitations}>
            {children}
          </CitationLink>
        ),
      }}
    >
      {text}
    </Markdown>
  );
}
